import { useBoolean } from 'ahooks';
import { Badge } from 'antd';
import React, { FC, useMemo } from 'react';
import { Project } from 'api/project';
import { Button } from 'components/atoms/button';
import { PlaceholderAvatarGroup } from 'components/molecules/placeholder-avatar';
import { PlaceholderResolutionModal } from './modal';
import { useUsersForProject } from './project-users';

interface Props {
  project: Project;
}
export const PlaceholderResolution: FC<Props> = ({ project }) => {
  const [
    placeholderModalVisible,
    {
      setTrue: showPlaceholderResolutionModal,
      setFalse: hidePlaceholderResolutionModal,
    },
  ] = useBoolean(false);
  const { placeholders } = useUsersForProject({ project });
  const hasSomeUnresolvedPlaceholders = useMemo(
    () => placeholders.some((placeholder) => placeholder.resolved !== true),
    [placeholders],
  );

  return (
    <>
      <Button
        icon={
          <Badge dot={hasSomeUnresolvedPlaceholders}>
            <PlaceholderAvatarGroup size={16} />
          </Badge>
        }
        type="text"
        onClick={showPlaceholderResolutionModal}
      />
      {placeholderModalVisible ? (
        <PlaceholderResolutionModal
          visible={placeholderModalVisible}
          onClose={hidePlaceholderResolutionModal}
          placeholders={placeholders}
          project={project}
        />
      ) : null}
    </>
  );
};
